jQuery(document).ready(function($) {

	if ( $('.timeline').length > 0 ) {

		var slider = $('.timeline--items');

		slider.flickity({
			cellAlign: 'left',
	  	contain: true,
			wrapAround : false,
			prevNextButtons : true,
			pageDots : false,
      adaptiveHeight: true
		});

    slider.on( 'change.flickity', function( event, index ) {
      var el         = $('.timeline--bar__list li').eq(index);
      var percentage = el.data('percentage');
      $('.timeline--bar__bar').css('width',percentage);
    });

		$(window).resize(function() {
			slider.flickity('resize');
		});

	}

});
